<ng-template #customItemTemplate let-model="item" let-index="index">
    @if (contentType === 'users') {
        @if (!model.isFake) {
            <div class="d-flex align-items-center mt-1 mb-1">
                @if (model.isSelected) {
                    <sb-inline-svg
                        class="icon check-icon me-2"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                    </sb-inline-svg>
                } @else {
                    <!--                todo: check for suplicated code-->
                    @if (!model.isContact) {
                        <sb-user-avatar class="user-avatar-btn" [user]="model" [size]="'btn'" [isNeedTooltip]="false">
                        </sb-user-avatar>
                    } @else {
                        <sb-inline-svg
                            class="icon check-icon me-2"
                            style="padding: 2px"
                            [url]="'/sb-tools/theme/images/icons/contact.svg'">
                        </sb-inline-svg>
                    }
                }

                <div class="truncate">
                    <div class="truncate text-light">
                        <span class="truncate-name">
                            {{ model.name | truncate: 23 }}
                        </span>
                        <small class="text-light"> {{ model.email }} </small>
                    </div>
                </div>
            </div>
        } @else {
            @if (isItemNotMatched) {
                <div
                    class="d-flex flex-wrap text-danger mt-1 fake-item"
                    [ngClass]="{ 'text-light': isNotFromListAllowed }">
                    @if (noResultMessage) {
                        <span>{{ noResultMessage }}</span>
                    } @else {
                        <span>{{ 'No users matching' | translate }}</span
                        >&nbsp;
                        <div class="truncate">"{{ selectedText.trim() }}</div>
                        "&nbsp;
                        <span>{{ 'were found.' | translate }}</span>
                    }
                </div>
            }
        }
    }

    @if (contentType === 'tags') {
        @if (!model.isFake) {
            <div class="truncate">
                {{ model[displayBy] }}
                @if (model.categoryName) {
                    <span class="text-light">({{ model.categoryName }})</span>
                }
            </div>
        } @else {
            @if (isItemNotMatched) {
                <div class="d-flex flex-wrap text-danger mt-1 fake-item">
                    <span>{{ 'No tags matching' | translate }}</span
                    >&nbsp;
                    <div class="truncate">"{{ selectedText.trim() }}</div>
                    "&nbsp;
                    <span>{{ 'were found.' | translate }}</span>
                </div>
            }
            @if (isTagCreationEnabled && isItemNotFound && selectedText.trim()) {
                <a>{{ 'Create a new one.' | translate }}</a>
            }
        }
    }
</ng-template>
<div
    class="tags-input-container form-control d-flex flex-wrap"
    [ngClass]="{
        'ng-invalid': (isItemNotMatched && !isNotFromListAllowed && selectedText) || isInvalid,
    }">
    @for (item of selectedItems; let idx = $index; track item) {
        <div class="tag truncate" [class.users-tag]="contentType === 'users'">
            @if (contentType === 'users') {
                @if (!item.isContact) {
                    <sb-user-avatar class="user-avatar-btn me-2" [user]="item" [size]="'btn'" [isNeedTooltip]="false">
                    </sb-user-avatar>
                } @else {
                    <sb-inline-svg
                        class="icon check-icon me-2"
                        style="padding: 2px"
                        [url]="'/sb-tools/theme/images/icons/contact.svg'">
                    </sb-inline-svg>
                }
            }
            <span class="tag-text truncate" [innerHtml]="item[displayBy] | replaceEmojis: false : true"> </span>
            <sb-inline-svg
                class="icon icon-close"
                aria-label="My icon"
                (click)="removeItem(idx); $event.preventDefault()"
                [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
            </sb-inline-svg>
        </div>
    }
    @if (maxItems === undefined || selectedItems.length < maxItems) {
        <input
            #typeaheadInput
            appFocus
            [attr.data-reply-id]="replyId"
            autocomplete="off"
            [container]="isContainerBody ? 'body' : ''"
            [appAutoFocus]="autofocus"
            [focusTimeout]="focusTimeout"
            [(ngModel)]="selectedText"
            [typeaheadOptionsLimit]="typeaheadOptionsLimit"
            [typeahead]="clonedItems"
            [typeaheadOptionField]="displayBy"
            [typeaheadGroupField]="typeaheadGroupField"
            [adaptivePosition]="isAdaptivePosition"
            [placeholder]="placeholder"
            [typeaheadItemTemplate]="customItemTemplate"
            [typeaheadMinLength]="typeaheadMinLength"
            [typeaheadSelectFirstItem]="false"
            [typeaheadIsFirstItemActive]="false"
            (typeaheadOnSelect)="onSelect($event)"
            [typeaheadScrollable]="true"
            [typeaheadOptionsInScrollableView]="typeaheadOptionsInScrollableView"
            (blur)="typeaheadOnBlur($event)"
            (keydown)="keyDownHandler($event)"
            (focus)="keyDownHandler($event); typeaheadOnFocus()" />
    }
</div>
